export function isPrimitive<T>(value: T): boolean {
    return value == null || typeof value !== 'object';
}

export function isNumber(value: any): boolean {
    return typeof value === 'number' && isFinite(value);
}

export function isIframe(): boolean {
    if (!globalThis?.window) return false;

    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export function isAboutBlank(): boolean {
    return window.location.href === 'about:blank' && window.location.origin === 'null';
}
